// extracted by mini-css-extract-plugin
export default {"root":"KuF2aPT7SBKl1JAGe8Kg","isDragging":"_gGbDt1Fb4naKRXX_xwd"};